export const DEFAULT_STEP_OPTIONS = {
  nextLabel: 'Próximo',
  prevLabel: 'Voltar',
  skipLabel: 'Pular',
  doneLabel: 'Concluir',
};

export const DEFAULT_HINT_OPTIONS = {
  hintButtonLabel: 'Encontrei',
};
